import { render, staticRenderFns } from "./AffiliateInquiriesPage.vue?vue&type=template&id=dff2bdc8&scoped=true&"
import script from "./AffiliateInquiriesPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateInquiriesPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateInquiriesPage.vue?vue&type=style&index=0&id=dff2bdc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff2bdc8",
  null
  
)

export default component.exports